import * as stylex from '@stylexjs/stylex';
import { MdAccessTime } from 'react-icons/md';
import { formatTime } from '~utils';
import { styles } from './styles';
import type { PublicBusinessHour } from '~pages/Spot/query';
const ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;
// JS getDay(): 0=Sunday … 6=Saturday.
const DOW_TO_DAY = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'] as const;
export function Hours({
  hours
}: {
  hours: PublicBusinessHour[];
}) {
  const byDay = new Map(hours.map(hour => [hour.day, hour]));
  const today = DOW_TO_DAY[new Date().getDay()];
  return <section {...stylex.props(styles.card)}>
      <div {...stylex.props(styles.header)}>
        <MdAccessTime size={20} {...stylex.props(styles.icon)} />
        <span {...stylex.props(styles.title)}>Opening Hours</span>
      </div>
      <div {...stylex.props(styles.rows)}>
        {ORDER.map(day => {
        const hour = byDay.get(day);
        const isToday = day === today;
        return <div key={day} {...stylex.props(styles.row)}>
              <span {...stylex.props(styles.day, isToday && styles.strong)}>{titleCase(day)}</span>
              <span {...stylex.props(styles.time, isToday && styles.strong)}>
                {hour ? `${formatTime(hour.openTime)} - ${formatTime(hour.closeTime)}` : 'Closed'}
              </span>
            </div>;
      })}
      </div>
    </section>;
}
function titleCase(day: string) {
  return day.charAt(0) + day.slice(1).toLowerCase();
}